const defaultResult = [true, 1000];
const noReconnect = [false, -1];
const reconnectInAWhile = [true, 5000];
const results = {
    1006: defaultResult,
    4000: noReconnect,
    4001: reconnectInAWhile
};
export const shouldSocketReconnect = (event) => {
    if (window.navigator.onLine === false) {
        return noReconnect;
    }
    if (typeof results[event.code] === "undefined") {
        return defaultResult;
    }
    return results[event.code];
};
//# sourceMappingURL=shouldSocketReconnect.js.map